import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { useTravels } from '../TravelContext';
import { useNavigate } from 'react-router-dom';

// Kalan gün sayısını hesapla
const calculateRemainingDays = (targetDate) => {
  if (!targetDate) return '—';
  const today  = new Date();
  const target = new Date(targetDate);
  today.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  const diff = target - today;
  return diff < 0 ? 'Geçti' : `${Math.ceil(diff / 86_400_000)} Gün`;
};

const MyDreamList = () => {
  const { travelData: travels = [] } = useTravels();
  const navigate = useNavigate();
    const handleAddClick = () => navigate('/');

  return (
    <>
      {/* Üst görsel bandı */}
      <div className="h-64 bg-gradient-to-r from-cyan-400 to-blue-500">
        <div
          className="h-full w-full bg-cover bg-center"
          style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/az-subtle.png')" }}
        />
      </div>

      {/* Ana içerik alanı */}
      <div className="font-sans bg-gray-50 dark:bg-gray-900 min-h-[calc(100vh-16rem)] -mt-15 pb-16 flex flex-col items-center px-4">
        <main className="w-full max-w-5xl">
          <section className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-3xl shadow-2xl p-6 sm:p-8 lg:p-10 -translate-y-16">
            
            {/* Başlık ve ekleme butonu */}
            <header className="flex justify-between items-center mb-8">
              <h2 className="text-3xl sm:text-4xl font-semibold">Hayal Listem</h2>
              <button
                onClick={handleAddClick}
                className="p-3 rounded-full bg-cyan-500 hover:bg-cyan-600 text-white shadow-lg focus:outline-none focus:ring-4 focus:ring-cyan-400"
                aria-label="Yeni hayal ekle"
              >
                <FaPlus />
              </button>
            </header>

            {/* Liste */}
            {travels.length === 0 ? (
              <p className="text-gray-500 dark:text-gray-300 text-center">
                Henüz bir hayal eklemediniz. Hemen plan oluşturun!
              </p>
            ) : (
              <ul className="space-y-4">
                {travels.map(t => (
                  <li
                    key={t.id}
                    className="bg-gray-100 dark:bg-slate-700 p-4 rounded-2xl"
                  >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                      <span className="font-semibold text-lg">{t.route}</span>
                      <span className="text-gray-600 dark:text-gray-300">{t.details?.budget || '—'}</span>
                      <span className="text-gray-600 dark:text-gray-300">{t.details?.startDate || 'Tarih Yok'}</span>
                      <span className="text-gray-600 dark:text-gray-300">{t.details?.days ? `${t.details.days} Gün` : '—'}</span>
                    </div>
                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                      {t.details?.startDate && `Kalan: ${calculateRemainingDays(t.details.startDate)}`}
                    </div>
                  </li>
                ))}
              </ul>
            )}

          </section>
        </main>
      </div>
    </>
  );
};

export default MyDreamList;
